/* eslint-disable max-len */
import React from 'react';

const TitleOneIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path
          d="M293 113v1h-4v11h-1v-11h-4v-1h9zm2 6v5h1v1h-3v-1h1v-4h-1v-1h2z"
          transform="translate(-284.000000, -113.000000)"
        />
      </g>
    </g>
  </svg>
);

export default TitleOneIcon;
